<template>
	<div class="menu-class">
		<div class="left">
			<div class="menu-icon" @click="hideMenu">
				<img :src="closeImg" />
			</div>
			<div class="content">
				<div class="item" @click="toMenu('-1')"><span v-if="language === 'zh'">首页</span><span v-else-if="language === 'en'">Home</span></div>
				<div class="item" :class="menuActiveIndex == index ? 'active' : ''" v-for="(item, index) in menuData" :key="index" @click="toMenu(index)">
					{{ item.name }}
				</div>
			</div>
		</div>
		<div class="right" @click="hideMenu"></div>
	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	name: 'Menu',
	data() {
		return {
			menuList: [
				{ id: 1, name: '成长能力', key: 'Grow', sort: 1 },
				{ id: 2, name: '营运能力', key: 'Operating', sort: 2 },
				{ id: 3, name: '盈利能力', key: 'Profitability', sort: 3 },
				{ id: 4, name: '偿债能力', key: 'Solvency', sort: 4 },
				{ id: 5, name: '公司简介', key: 'Profile', sort: 5 },
				{ id: 6, name: '股东数量及持股情况', key: 'Shareholders', sort: 6 },
				{ id: 7, name: '公告原文', key: 'Announcement', sort: 7 },
				{ id: 8, name: '现金获取能力', key: 'Cash', sort: 8 },
				{ id: 9, name: '业绩亮点', key: 'Performance', sort: 9 },
				{ id: 10, name: '公司风采', key: 'cStyle', sort: 10 },
				{ id: 11, name: '董事长寄语', key: 'Chairman', sort: 11 },
			],
			menuData: [],
		}
	},
	computed: {
		...mapState(['theme', 'language', 'menuActiveIndex', 'jsonData']),
		closeImg() {
			return require('../assets/image/' + this.theme + '/close.png')
		},
	},
	watch: {
		language(newData, oldData) {
			if (newData == 'zh') {
				this.menuData = JSON.parse(this.jsonData.moduleData)
			} else {
				this.menuData = JSON.parse(this.jsonData.moduleDataEng)
			}
		},
	},
	mounted() {
		if (this.language == 'zh') {
			this.menuData = JSON.parse(this.jsonData.moduleData)
		} else {
			this.menuData = JSON.parse(this.jsonData.moduleDataEng)
		}
	},
	methods: {
		hideMenu() {
			this.$emit('hideMenu')
		},
		toMenu(index) {
			this.$emit('toMenu', index)
		},
	},
}
</script>

<style scoped>
.menu-class {
	display: flex;
}
.menu-icon {
	position: absolute;
	top: 40px;
	left: 50px;
	cursor: pointer; /* 设置光标形状为手型 */
}

.menu-icon img {
	width: 28px;
	height: 25px;
}

.content {
	margin-top: 85px;
	margin-left: 50px;
}

.item {
	height: 20px;
	font-size: 14px;
	font-weight: 400;
	color: var(--timeTitleColor);
	line-height: 20px;
	margin-bottom: 18px;
	cursor: pointer; /* 设置光标形状为手型 */
}

.active {
	font-weight: 600;
	color: var(--baseColor);
}
.left {
	position: relative;
	width: 258px;
	height: 720px;
	background: #ffffff;
}
.right {
	position: fixed;
	top: 0;
	right: 0;
	width: 882px;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
	z-index: 2; /* 确保遮罩层在内容区域之上 */
}
</style>
